import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import AuthCover from '../../images/content/AuthCover.svg';

const Cover = styled(Grid)(() => ({
  backgroundImage: `url(${AuthCover})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

const AuthSideCover = () => <Cover item xs={false} sm={4} md={7} />;

export default AuthSideCover;
